module.exports = __webpack_public_path__ + "img/supervision_1280.31800d9b.png";